import { Form, Input, Typography } from 'antd';
import React, { useEffect, useState } from 'react';

function RequestInfo({ readOnly }) {
  const Reason = ({ readOnly1, value, onChange }) => {
    const [text, setText] = useState('');

    useEffect(() => {
      setText(value);
    }, [value]);

    return readOnly1 ? (
      <Typography.Text style={{ whiteSpace: 'pre-line' }}> {text}</Typography.Text>
    ) : (
      <Input.TextArea
        value={text}
        onBlur={() => {
          onChange(text);
        }}
        onChange={(e) => setText(e.target.value)}
      />
    );
  };

  const Applicant = ({ value }) => {
    const name = localStorage.getItem('username');
    return <Typography.Text> {`${name}( ${value} )`}</Typography.Text>;
  };
  return (
    <>
      <Form.Item label="신청자" name="applicant" required>
        <Applicant />
      </Form.Item>
      {/* TODO: 신청일은 RUD 일때만 보이기 */}
      {readOnly && (
        <Form.Item label="신청 일시" name="applyDate" required>
          <Input readOnly={readOnly} bordered={false} />
        </Form.Item>
      )}
      <Form.Item
        label="신청 사유"
        name="reason"
        rules={[{ required: true, message: '필수 입력 항목 입니다.' }]}
      >
        <Reason readOnly1={readOnly} />
      </Form.Item>
    </>
  );
}

export default RequestInfo;
